import React, {useEffect, useMemo} from "react";
import {Modal, Table} from "react-bootstrap";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {ModalProgressBar} from "../../../../_metronic/_partials/controls";
import * as formatter from "../../../../utils/formatter";
import * as actions from "../../../../redux/modules/samples/actions";
import {SAMPLE_REQUEST_STATUS} from "../../../../utils/codes";

export function SampleDetailModal({show, onHide, sampleId}) {
  // Products Redux state
  const dispatch = useDispatch();
  const {isLoading, sample} = useSelector(
    (state) => ({
      isLoading: state.samples.actionsLoading,
      sample: state.samples.sample,
    }),
    shallowEqual
  );

  const format = useMemo(() => ({
    ChipFormatter: formatter.chip(SAMPLE_REQUEST_STATUS),
    DateFormatter: formatter.dateTime,
    OptionsFormatter: formatter.goodsDetailOpt,
    PriceFormatter: formatter.price,
  }), []);

  useEffect(() => {
  }, [isLoading, dispatch]);

  useEffect(
    () => {
      if (sampleId) {
        dispatch(actions.fetchSample(sampleId));
      }
    },
    [sampleId, dispatch]
  );

  if (!sample) return null;

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        size="lg"
        aria-labelledby="example-modal-sizes-title-lg"
        centered
      >
        {isLoading && <ModalProgressBar/>}
        <Modal.Header>
          <div>
            <h3>샘플 신청 상세</h3>
            <span className="text-dark-50">샘플 신청 상세 정보를 확인하세요.</span>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Table responsive borderless>
            <colgroup>
              <col width="20%"/>
              <col width="30%"/>
              <col width="20%"/>
              <col width="30%"/>
            </colgroup>
            <tbody>
            <tr>
              <th>처리 상태</th>
              <td>{format.ChipFormatter(sample.rplySttsCd)}</td>
              <th>신청 일시</th>
              <td>{format.DateFormatter(sample.regDtime)}</td>
            </tr>
            </tbody>
          </Table>

          <p className="font-weight-boldest text-primary mt-6 mb-2">샘플 신청 상품 정보</p>
          <Table bordered>
            <colgroup>
              <col width="20%"/>
              <col width="30%"/>
              <col width="20%"/>
              <col width="30%"/>
            </colgroup>
            <tbody>
            <tr>
              <th>상품명</th>
              <td colSpan={3}>{sample.goodsNm}</td>
            </tr>
            <tr>
              <th>옵션</th>
              <td colSpan={3}>
                {format.OptionsFormatter(sample.goodsOptList)}
              </td>
            </tr>
            <tr>
              <th>상품 코드</th>
              <td>{sample.goodsNo}</td>
              <th>공급 파트너</th>
              <td>{sample.providerId} ({sample.providerBsnOprName})</td>
            </tr>
            <tr>
              <th>상품 공급가</th>
              <td colSpan={3}>{format.PriceFormatter(sample.salePrc)}</td>
            </tr>
            </tbody>
          </Table>

          <p className="font-weight-boldest text-primary mt-6 mb-2">답변 내용</p>
          {sample.rplySttsCd === '01' ? (
            <p className="font-weight-boldest text-danger mb-2">
              빠른 시일 내에 확인 후 답변 드리도록 하겠습니다.
            </p>
          ) : (
            <p className="border border-1 p-5 border-dark">{sample.ansConts}</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button
              type="button"
              className="btn btn-dark btn-elevate w-130px"
              onClick={onHide}
            >
              확인
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
